import Account from "@/components/Settings/Account";
import OrganizationProfile from "@/components/Settings/OrganizationProfile";
import Subscription from "@/components/Settings/Subscription";
import TeamManagement from "@/components/Settings/TeamManagement";
import Tooltip from "@/components/Tooltip";
import useBreadCrumb from "@/context/BreadCrumbContext";
import React, { useEffect } from "react";

const Settings = () => {
	const { setBreadCrumb } = useBreadCrumb();
	const [currentTab, setCurrentTab] = React.useState(
		localStorage.getItem("currentTab") || "Account"
	);
	const role = localStorage.getItem("role");
	const isCompanyAdmin = localStorage.getItem("isCompanyAdmin") === "true";

	const allItems = [
		"Account",
		"Organization Profile",
		"Team Management",
		"Subscription Management",
	];

	const getVisibleItems = () => {

		if (role === "guest") return allItems;

		if (role === "Talentick_admin" && isCompanyAdmin)
			return allItems;
		if (role === "Talentick_admin" && isCompanyAdmin === false)
			return ["Account", "Organization Profile", "Team Management"];

		if (role === "Talentick_user" || role === "bluetick-admin") return ["Account", "Organization Profile"];
		return [];
	};

	const isDisabled = (item: string) => {
		return (
			role === "guest" &&
			(item === "Organization Profile" || item === "Team Management")
		);
	};
	const handleTabChange = (tab: string) => {
		setCurrentTab(tab);
	};
	useEffect(() => {
		setBreadCrumb({
			mainLabel: {
				label: "Settings",
				link: "settings",
			},
			currentLabel: currentTab,
		});
	}, [currentTab]);
	return (
		<div className="bg-white px-4 pt-3 rounded-lg w-full min-h-[85vh] ">
			<h1 className="text-xl font-semibold  w-full md:w-auto   font-heading mb-3 border-b pb-2">
				Settings
			</h1>
			<div className="md:grid grid-cols-[20%_75%] gap-4 mt-4">
				{/* side bar */}
				<div className="flex md:block justify-between mb-3">
					{getVisibleItems().map((item) => (
						<button
							key={item}
							disabled={isDisabled(item)}
							className={`${currentTab === item
								? "font-semibold text-black"
								: "text-gray-700"
								} flex items-center text-left gap-2 p-2 text-xs md:text-sm hover:bg-gray-100 rounded-md cursor-pointer`}
							onClick={() => handleTabChange(item)}
						>
							{item}
							{isDisabled(item) && (
								<Tooltip>
									<p>
										This feature is exclusive to paid subscribers. Please upgrade to unlock full access.
									</p>
								</Tooltip>
							)}
						</button>
					))}
				</div>

				{/* content */}
				<div className="border-l-2 border-gray-200 px-4 min-h-[75vh] overflow-auto">
					{currentTab === "Account" && <Account />}
					{currentTab === "Organization Profile" && <OrganizationProfile />}
					{currentTab === "Team Management" && <TeamManagement />}
					{currentTab === "Subscription Management" && <Subscription />}
				</div>
			</div>
		</div>
	);
};

export default Settings;
